import { useTranslation } from "react-i18next"

import type { PaymentMethodNameEnum } from "@/enums"
import type { CycleStatusEnum } from "@/enums/subscriptions"

import { Badge } from "../ui/badge"
import { getCycleStatusInfo } from "./SubscriptionsHelper"

interface CycleStatusBadgeProps {
  status: CycleStatusEnum | string
  paymentMethod?: PaymentMethodNameEnum
}

export const CycleStatusBadge = ({
  status,
  paymentMethod,
}: CycleStatusBadgeProps) => {
  const { t } = useTranslation()
  const { label, bgColor } = getCycleStatusInfo(
    status as CycleStatusEnum,
    t,
    paymentMethod
  )

  return (
    <Badge
      variant="none"
      className="flex h-fit items-center justify-start gap-1 rounded-full"
    >
      <div
        className="rounded-full px-2 py-1 text-white"
        style={{ backgroundColor: bgColor }}
      >
        {label}
      </div>
    </Badge>
  )
}
